import React from 'react';
import {MT7_CREATE_CLIENT} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useMutation} from "@apollo/client";
import waitingGif from "../../../../static/img/waiting.gif";
import "./MutationCreateClient.css";

function MutationCreateClient (props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    const [MT7CreateClient, { loading, error }] = useMutation(MT7_CREATE_CLIENT);
    if (loading) return <div className='MutationCreateClientLoading'><img src={waitingGif} alt='Ifyoudontseeimages' width='27px' height='27px' /><TextSource ArrIndex= 'TraderOpen0190'>Идет регистрация аккаунта</TextSource></div>;

    if (error) {
        if (error.message.indexOf('EmailExist')+1) return (<div>
            <p><div className='MutationCreateResult'><TextSource ArrIndex= 'TraderOpen0090'>Внимание: данный e-mail уже зарегистрирован в системе. Восстановить пароль вы можете на сайте</TextSource></div> </p>
            <div className='ButtonBlue' role="button" tabIndex={0} onKeyPress={() => {}}
                 onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
                 { await MT7CreateClient({ variables: { email : props.Email, name : props.Name, password : props.Password, ClientID: props.ClientID, agentTag: props.agentTag } })
                     .then(async ({ data }) => {
                         props.DoRegistration(data);
                     })}}}
            ><TextSource ArrIndex= 'TraderOpen0100'>Открыть торговый счет</TextSource> </div>
        </div>); else  if (error.message.indexOf('must match pattern')+1) return (<div>
            <p><div className='MutationCreateResult'><TextSource ArrIndex= 'TraderOpen0195'>Такой e-mail невозможен</TextSource></div> </p>
            <div className='ButtonBlue' role="button" tabIndex={0} onKeyPress={() => {}}
                 onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
                 { await MT7CreateClient({ variables: { email : props.Email, name : props.Name, password : props.Password, ClientID: props.ClientID, agentTag: props.agentTag } })
                     .then(async ({ data }) => {
                         props.DoRegistration(data);
                     })}}}
            ><TextSource ArrIndex= 'TraderOpen0100'>Открыть торговый счет</TextSource> </div>
        </div>);
        else return (<div>
            <p>Error: ${error.message}</p>;
            <div className='ButtonBlue' role="button" tabIndex={0} onKeyPress={() => {}}
                 onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
                 { await MT7CreateClient({ variables: { email : props.Email, name : props.Name, password : props.Password, ClientID: props.ClientID, agentTag: props.agentTag } })
                     .then(async ({ data }) => {
                         props.DoRegistration(data);
                     })}}}
            ><TextSource ArrIndex= 'TraderOpen0105'>Открыть торговый счет</TextSource> </div>
        </div>);
    }
    return (
                        <div className='ButtonBlue' role="button" tabIndex={0} onKeyPress={() => {}}
                             onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
                             { await MT7CreateClient({ variables: { email : props.Email, name : props.Name, password : props.Password, ClientID: props.ClientID, agentTag: props.agentTag } })
                                 .then(async ({ data }) => {
                                     props.DoRegistration(data);
                                 })}}}
                        ><TextSource ArrIndex= 'TraderOpen0110'>Открыть торговый счет</TextSource> </div>
    )}
export default MutationCreateClient